import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import 'react-widgets/dist/css/react-widgets.css';
import "react-datepicker/dist/react-datepicker.css";
import './assets/scss/style.scss';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router, Link, Route, Switch } from "react-router-dom";
import PrivateRoute from "./auth/components/PrivateRoute";
import 'react-toastify/dist/ReactToastify.css';
import Login from "./views/Login";
import axios from "axios"


import { Provider } from "react-redux";
import store from "./redux/store";
import { getLocalAuthToken } from "./helper/utils";
import { ToastContainer } from "react-toastify";

// Dh
import DhList from "./views/dh/List";
import DhCommission from "./views/dh/Commission";
import DhDetails from "./views/dh/Details";
import CTList from "./views/commissionTransactions/List"
import CTDetails from "./views/commissionTransactions/Details"

// Purchase Orders
import PoList from "./views/purchaseOrder/List";
import PoDetail from "./views/purchaseOrder/Details";
import PoAdd from "./views/purchaseOrder/NewAdd";

// Purchase Orders
import BAList from "./views/bankAccounts/List";

// Orders Cash Collection
import OrderCashCollectionList from "./views/dhCollections/List";
import OrderCashCollectionDetail from "./views/dhCollections/Details";


// Suppliers
import SList from "./views/supplier/List";
import SupplierPayments from "./views/supplierPayments/List"
import ProductAssign from "./views/supplier/NewProductAssign";
import EditProductAssign from "./views/supplier/EditProductAssign";

import Collections from "./views/srRiderCollection/Collections"

import OPCRList from "./views/orderPayCollectionReport/List";
import CustomerAcquisition from './views/CustomerAcquisition/CustomerAcquisition';

const authData = getLocalAuthToken() ? getLocalAuthToken().message : '';

axios.defaults.headers.common['Authorization'] = authData?.token || ''
axios.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (error?.response?.status === 401) {
        localStorage.clear()
        window.location.replace("/login")
    } else {
        return error.response;
    }
})

ReactDOM.render(
    <Provider store={store}>
        <Router>
            <Switch>
                <Route exact path="/login">
                    <Login />
                </Route>

                <PrivateRoute exact path="/">
                    <DhList />
                </PrivateRoute>

                <PrivateRoute exact path="/dh/list">
                    <DhList />
                </PrivateRoute>

                <PrivateRoute exact path="/payment-collection">
                    <OPCRList />
                </PrivateRoute>
                <PrivateRoute exact path="/customer-acquisition">
                    <CustomerAcquisition />
                </PrivateRoute>

                <PrivateRoute exact path="/commssion-transactions/list">
                    <CTList />
                </PrivateRoute>

                <PrivateRoute exact path="/commssion-transactions/details/:id">
                    <CTDetails />
                </PrivateRoute>

                <PrivateRoute exact path="/dh/commission/:id">
                    <DhCommission />
                </PrivateRoute>

                <PrivateRoute exact path="/dh/details/:id">
                    <DhDetails />
                </PrivateRoute>

                <PrivateRoute exact path="/purchaseOrder/list">
                    <PoList />
                </PrivateRoute>

                <PrivateRoute exact path="/purchaseOrder/details/:id">
                    <PoDetail />
                </PrivateRoute>

                <PrivateRoute exact path="/purchaseOrder/add">
                    <PoAdd />
                </PrivateRoute>

                <PrivateRoute exact path="/bank-accounts/list">
                    <BAList />
                </PrivateRoute>

                <PrivateRoute exact path="/dh-collections/list">
                    <OrderCashCollectionList />
                </PrivateRoute>

                <PrivateRoute exact path="/dh-collections/details/:id">
                    <OrderCashCollectionDetail />
                </PrivateRoute>

                <PrivateRoute exact path="/supplier/list">
                    <SList />
                </PrivateRoute>

                <PrivateRoute exact path="/supplier-payments">
                    <SupplierPayments />
                </PrivateRoute>

                <PrivateRoute exact path="/supplier/assign-product/:id">
                    <ProductAssign />
                </PrivateRoute>

                <PrivateRoute exact path="/supplier/edit-assign-product/:id">
                    <EditProductAssign />
                </PrivateRoute>

                <PrivateRoute exact patch="/sr-rider-collections">
                    <Collections />
                </PrivateRoute>

                <Route>
                    <p>404 | Page not found</p>
                    <p><Link to="/">Back to Home</Link></p>
                </Route>

            </Switch>
        </Router>

        <ToastContainer position="bottom-right" autoClose={3000} />
    </Provider>
    , document.getElementById('root'));

serviceWorker.unregister();
